import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";
import "react-multi-date-picker/styles/layouts/mobile.css"
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import Select from "react-select";

const currencyFormat = Intl.NumberFormat('en-US');
function VendorProductReports
() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [reportLoaded, setReportLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [reports, setReports] = React.useState([]);
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');
    const [vendor, setVendor] = React.useState([]);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedOptions, setSelectedOptions] = React.useState();

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {
                setIsLoaded(true)
                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }

            })
            .catch((error) => {
                if (error.response) {

                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        const params = {
            processFor: 'Suppliers',
            vendor_id: window.localStorage.getItem("vendor"),
            vendor: window.localStorage.getItem("vendor"),
            orderBy: 'id',
            orderType: 'desc',

        }
        API.getVendor(params)
            .then((response) => {
                setIsLoaded(true);
                setVendor(response.data)
                const groups = response.data.products;
                let options = [];
                for(let data in groups) {

                    options.push({
                        value : groups[data].id,
                        label : groups[data].name,
                    })
                }
                setSelectOptions(options)
            })
            .catch((error) => {
                setTimeout (() => {
                    navigate(`/vendor/select`)
                },400)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    const onLoadReport = () => {

        if(!selectedOptions?.value) {
            toast.error('کالای مورد نظر را انتخاب کنید');
            return false
        }

        if(dateFrom.length < 3 || dateTo.length < 3) {
            toast.error('بازه تاریخی را انتخاب کنید');
            return false
        }

        const toMonth = dateTo?.toDate?.().getMonth() -(-1);
        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const params = {
            product_id: selectedOptions?.value,
            vendor_id: window.localStorage.getItem("vendor"),
            dateFrom : dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' + dateFrom?.toDate?.().getDate() + ' 00:00' ,
            dateTo : dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59' ,
        }
        setIsLoaded(false)
        API.getProductReport(params)
            .then((response) => {
                setReports(response.data)
                setIsLoaded(true)
                setReportLoaded(true)

            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }
    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}

                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}
                                         id='active'
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 ">
                        <div className="row pb-5 px-2 main-part">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                               گزارش فروش کالا
                                <div className='text-small-3 text-secondary mt-3 opacity-75'>
  (
                                    {
                                        window.localStorage.getItem("vendorTitle")
                                    }
                                    )
                                </div>

                            </div>
                            <div className="col-md-12 mb-3">
                                <label htmlFor="floatingInput">
                                    انتخاب  کالا
                                </label>

                                <div className="form-floating mb-3">
                                    <Select
                                        options={selectOptions}
                                        placeholder=" کالا"
                                        value={selectedOptions}
                                        isSearchable={true}
                                        onChange={
                                            (event) => {
                                                setSelectedOptions(event)
                                            }
                                        }
                                    />


                                </div>
                            </div>
                            <div className="col-md-4 mb-3">
                                <span className='text-small-2 mx-3'>
                                    از تاریخ
                                </span>
                                <DatePicker
                                    onChange={ (val) => setDateFrom(val)}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition= "bottom-right"
                                    className="rmdp-mobile"

                                />
                            </div>
                            <div className="col-md-4 mb-3">
                            <span className='text-small-2 mx-3'>
                                    تا تاریخ
                                </span>
                                <DatePicker
                                    onChange={ (val) => setDateTo(val)}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition= "bottom-right"
                                    className="rmdp-mobile"

                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <button className='btn btn-primary w-100'
                                 onClick={onLoadReport}
                                >
                                    مشاهده گزارش
                                </button>
                            </div>
                            {
                                reportLoaded ?
                                    <div className="col-12">
                                        <div className="row alert alert-success">
                                            <div className="col-6">
                                                تعداد فاکتور:
                                            </div>
                                            <div className="col-6 text-start">
                                                {
                                                    reports.orderCount
                                                }
                                                &nbsp;
                                                فاکتور
                                            </div>
                                        </div>
                                        <div className="row alert alert-info">
                                            <div className="col-6">
                                                تعداد کل فروش:
                                            </div>
                                            <div className="col-6 text-start">
                                                {
                                                    reports.salesCount
                                                }
                                                &nbsp;
                                                عدد
                                            </div>
                                        </div>
                                        <div className="row alert alert-primary">
                                            <div className="col-6">
                                                مبلغ کل فروش:
                                            </div>
                                            <div className="col-6 text-start">
                                                {
                                                    currencyFormat.format(reports.sumPrice)

                                                }
                                                &nbsp;
                                                ریال
                                            </div>
                                        </div>
                                    </div> :
                                    <div className="col-12 vh-50">
                                        &nbsp;
                                        <div className="alert alert-warning text-small-2 text-center">
                                            برای مشاهده گزارش  فروش یک کالا ابتدا کالای مورد نظر و بازه تاریخی  را انتخاب کرده و سپس دکمه مشاهده گزارش را بزنید
                                        </div>
                                    </div>
                            }
                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default VendorProductReports
;